export enum UnitPositionEnum {
  None = 'None',
  Center = 'Center',
  Corner = 'Corner'
}

export const getUnitPositionString = (position: any): string | null => {
  if (position == null) {
    return null;
  }

  if (typeof position === 'string') {
    return position;
  }

  const positionMap: { [key: number]: string } = {
    0: 'None',
    1: 'Center',
    2: 'Corner'
  };

  return positionMap[position] || null;
};

/**
 * Retourne le texte traduit de la position, ou null si None/null/undefined.
 * @param position - Valeur brute de la position (number, string, ou enum)
 * @param t - Fonction de traduction i18n
 */
export const getUnitPositionText = (position: any, t: (key: string) => string): string | null => {
  const positionString = getUnitPositionString(position);

  if (!positionString || positionString === UnitPositionEnum.None) {
    return null;
  }

  return t(`browsingApp.statuses.unitPosition.${positionString}`);
};
